/**
 * RTL (Right-to-Left) language detection utilities
 *//**
 * List of RTL language codes (ISO 639-1)
 */const RTL_LANGUAGES=new Set(['ar','he','fa','ur']);/**
 * Determines if a locale is RTL using Intl.Locale
 * Falls back to checking against known RTL language codes
 */export function isRTL(locale:string):boolean{// Normalize to BCP 47 format (e.g., en_US -> en-US)
const normalizedLocale=locale.replace('_','-');try{// Use Intl.Locale to get text direction info
const intlLocale=new Intl.Locale(normalizedLocale);// @ts-expect-error textInfo is not in TS types yet but is widely supported
if(intlLocale.textInfo?.direction){// @ts-expect-error textInfo is not in TS types yet but is widely supported
return intlLocale.textInfo.direction==='rtl';}}catch{// Fall through to fallback
}// Fallback: extract language code and check against known RTL languages
const langCode=(normalizedLocale.split('-')[0]??'').toLowerCase();return RTL_LANGUAGES.has(langCode);}/**
 * Returns the text direction for a locale
 */export function getTextDirection(locale:string):'rtl'|'ltr'{return isRTL(locale)?'rtl':'ltr';}